export const GAM_CONSOLE_URL = "https://admanager.google.com";
